import gsap from "gsap";

export default class Animations {
	constructor() {
		this.init();
	}

	init() {
		this.parallaxMainImages = document.querySelectorAll("[js-parallax-image-main]");
		this.parallaxShapeImages = document.querySelectorAll("[js-parallax-image-shape]");

		this.initAnimations();
	}

	initAnimations() {
		// this.createTitleSpans();
		// this.initTitleAnimations();
		this.initParallaxMainAnimations();
		this.initParallaxShapeAnimations();
		this.heroFadeAnimations();
	}

	initParallaxMainAnimations() {
		this.parallaxMainImages.forEach((image) => {
			const container = image.closest("[js-parallax-image-container]");
			const type = image.getAttribute("data-parallax-type");

			switch (type) {
				case "x":
					gsap.fromTo(
						image,
						{ xPercent: 0 },
						{
							xPercent: -30,
							scrollTrigger: {
								trigger: container,
								scrub: 1,
							},
						}
					);
					break;

				case "y":
					gsap.fromTo(
						image,
						{ yPercent: 0 },
						{
							yPercent: 30,
							scrollTrigger: {
								trigger: container,
								scrub: 1,
							},
						}
					);
					break;

				case "scale":
					gsap.fromTo(
						image,
						{ scale: 1 },
						{
							scale: 1.5,
							scrollTrigger: {
								trigger: container,
								scrub: 1,
							},
						}
					);
					break;

				default:
					break;
			}
		});
	}

	initParallaxShapeAnimations() {
		this.parallaxShapeImages.forEach((image) => {
			const container = image.closest("[js-parallax-image-container]");

			gsap.fromTo(
				image,
				{ xPercent: 0, yPercent: 0 },
				{
					xPercent: -30,
					yPercent: -30,
					scrollTrigger: {
						trigger: container,
						scrub: 1,
					},
				}
			);
		});
	}

	createTitleSpans() {
		const titles = document.querySelectorAll("[js-title]");

		titles.forEach((title) => {
			const text = title.textContent.trim();

			// Split text into words and map each word to the required structure
			const words = text
				.split(" ")
				.map((word) => {
					const letters = word
						.split("")
						.map((letter) => {
							return `<span class="letter">${letter}</span>`;
						})
						.join("");

					// Wrap each word inside a span.word
					return `<span class="word">${letters}</span>`;
				})
				.join(" "); // Join words with spaces to maintain word breaks

			// Replace the content of js-title with the new HTML structure
			title.innerHTML = words;
		});
	}

	initTitleAnimations() {
		const items = document.querySelectorAll("[js-title]");

		items.forEach((item) => {
			const spans = item.querySelectorAll(".letter");
			const container = item.closest("[js-section]");
			const letters = gsap.utils.toArray(spans);

			gsap.fromTo(
				letters,
				{ yPercent: 100, scale: 1.3 },
				{
					yPercent: 0,
					scale: 1,
					duration: 0.8,
					ease: "expo.out",
					stagger: 0.05,
					scrollTrigger: {
						trigger: container,
					},
				}
			);
		});
	}

	heroFadeAnimations() {
		const itemContainer = "[js-container]";

		let mm = gsap.matchMedia();
		mm.add("(min-width: 769px)", (context) => {
			const itemLeft = "[js-x-left]";
			const itemRight = "[js-x-right]";

			gsap.fromTo(
				itemLeft,
				{ xPercent: -100 },
				{
					xPercent: 0,
					scrollTrigger: {
						trigger: itemContainer,
						scrub: 1,
						start: "top bottom",
						end: "bottom +=60%",
					},
				}
			);

			gsap.fromTo(
				itemRight,
				{ xPercent: 100 },
				{
					xPercent: 0,
					scrollTrigger: {
						trigger: itemContainer,
						scrub: 1,
						start: "top bottom",
						end: "bottom +=60%",
					},
				}
			);
		});
	}
}
